import {PanelOutputGroup} from '../models/panel-output-group';
import {PanelOutputLockingStatus} from '../models/panel-output-locking-status';
import {PanelOutput} from '../models/panel-output.interface';

export const updatePanelOutputGroupLockingStatus = (group: PanelOutputGroup): PanelOutputLockingStatus => {
  group.status = PanelOutputLockingStatus.Unlocked;
  group.isLockdown = true;
  group.outputs.forEach(output => {
    if (output.status === PanelOutputLockingStatus.Locked) {
      group.status = PanelOutputLockingStatus.Locked;
    }
    if (!output.isLockdown) {
      group.isLockdown = false;
    }
  });
  return group.status;
};


const updateGroupOutputs = (group: PanelOutputGroup, output: PanelOutput): PanelOutputGroup => {

  if (output.status === PanelOutputLockingStatus.Locked && group.lockedOutputs) {
    group.lockedOutputs.push(output);
  } else if (output.status === PanelOutputLockingStatus.Locked && !group.lockedOutputs) {
    group.lockedOutputs = [output];
  } else if (output.status === PanelOutputLockingStatus.Unlocked && group.unlockedOutputs) {
    group.unlockedOutputs.push(output);
  } else if (output.status === PanelOutputLockingStatus.Unlocked && !group.unlockedOutputs) {
    group.unlockedOutputs = [output];
  }
  return group;
};

// tslint:disable-next-line: no-unused-expression
export const groupByGroup = (flatOutputs: PanelOutput[]): PanelOutputGroup[] => {
  flatOutputs.forEach((output: PanelOutput) => {
    output.groups.forEach((group: PanelOutputGroup) => {
      group.unlockedOutputs = [];
      group.lockedOutputs = [];
    });
  });
  let list: PanelOutputGroup[] = [];
  flatOutputs.forEach((output: PanelOutput) => {
    output.groups.forEach((group: PanelOutputGroup) => {
      const index = list.findIndex(existingGroup => existingGroup.id === group.id);
      if (index !== -1) {
        list[index].outputs.push(output);
        list[index] = updateGroupOutputs(list[index], output);
        list[index].status = updatePanelOutputGroupLockingStatus(list[index]);
      } else {
        const newGroup = updateGroupOutputs(group, output);
        newGroup.outputs = [output];
        list.push(newGroup);
        list[0].status = updatePanelOutputGroupLockingStatus(list[0]);
      }
    });
  });
  return list;
};


